import api from "../../index";

export const GetSalesDashboardApi = (params) => api.get(`salesdashboard/get-sales-lead-dashboard?${params}`);